/* "Estamos trabajando" · Imprimirlo
 * Ayudante compartido por el montador, las fichas de transfers, las tarjetas
 * y los packs. Tres cosas:
 *   - Cargando.ocupar/pct/libre : el botón se queda con rueda y, en las subidas,
 *     con el porcentaje de verdad.
 *   - Cargando.velo             : tapa una zona mientras se lee o se arregla un archivo.
 *   - Cargando.pinta            : deja que el navegador pinte ANTES de bloquear el hilo.
 *     Sin esto la rueda no llega a aparecer, porque el análisis de píxeles
 *     ocupa el hilo principal y el navegador no repinta hasta que acaba.
 */
(function () {
  'use strict';

  var C = {};

  C.pinta = function () {
    return new Promise(function (listo) {
      if (typeof requestAnimationFrame !== 'function') return setTimeout(listo, 0);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { setTimeout(listo, 0); });
      });
    });
  };

  C.ocupar = function (btn, texto, conPorcentaje) {
    if (!btn) return;
    if (btn._crgTxt == null) btn._crgTxt = btn.textContent;
    btn.setAttribute('data-crg', conPorcentaje ? 'pct' : 'indet');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.style.setProperty('--crg-p', '0%');
    btn.innerHTML = '<span class="crg-int"><span class="crg-rueda" aria-hidden="true"></span>' +
      '<span data-crg-txt></span></span>';
    btn.querySelector('[data-crg-txt]').textContent = texto || 'Un momento…';
  };

  C.pct = function (btn, p, texto) {
    if (!btn || !btn.hasAttribute('data-crg')) return;
    if (document.documentElement.classList.contains('crg-quieto')) return;   // sin repintar por cada paquete subido
    p = Math.max(0, Math.min(100, p || 0));
    btn.setAttribute('data-crg', 'pct');
    btn.style.setProperty('--crg-p', Math.round(p) + '%');
    var t = btn.querySelector('[data-crg-txt]');
    if (t) t.textContent = (texto || 'Subiendo') + ' · ' + Math.round(p) + ' %';
  };

  // vuelve a dejar el botón normal; si se le pasa texto, lo pone
  C.libre = function (btn, texto) {
    if (!btn) return;
    if (!btn.hasAttribute('data-crg')) { if (texto != null) btn.textContent = texto; return; }
    btn.removeAttribute('data-crg');
    btn.removeAttribute('aria-busy');
    btn.style.removeProperty('--crg-p');
    btn.disabled = false;
    btn.textContent = texto != null ? texto : (btn._crgTxt || '');
    btn._crgTxt = null;
  };

  /* Tapa una zona. Devuelve la función que la destapa; llamarla dos veces no rompe nada. */
  C.velo = function (el, texto, nota) {
    if (!el) return function () {};
    if (el._crgVelo) {
      var t0 = el._crgVelo.querySelector('[data-crg-txt]');
      if (t0 && texto) t0.textContent = texto;
      return el._crgCerrar;
    }
    el.classList.add('crg-rel');
    var v = document.createElement('div');
    v.className = 'crg-velo';
    v.setAttribute('role', 'status');
    v.innerHTML = '<span class="crg-rueda" aria-hidden="true"></span><span data-crg-txt></span>' +
      (nota ? '<span class="crg-velo__nota"></span>' : '');
    v.querySelector('[data-crg-txt]').textContent = texto || 'Un momento…';
    if (nota) v.querySelector('.crg-velo__nota').textContent = nota;
    // la zona de subida suele ser un <label>: si no se para el clic, se vuelve
    // a abrir el selector de archivos por debajo del velo
    v.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    el.appendChild(v);
    el._crgVelo = v;
    el._crgCerrar = function () {
      if (!el._crgVelo) return;
      el._crgVelo.remove(); el._crgVelo = null;
      el.classList.remove('crg-rel');
    };
    return el._crgCerrar;
  };

  // pastilla "calculando…"; con texto null se esconde
  C.pill = function (el, texto) {
    if (!el) return;
    if (texto == null) { el.hidden = true; el.innerHTML = ''; return; }
    el.className = 'crg-pill';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="crg-rueda" aria-hidden="true"></span><span data-crg-txt></span>';
    el.querySelector('[data-crg-txt]').textContent = texto;
    el.hidden = false;
  };

  /* Aviso flotante (archivo demasiado pesado, diseño vacío…). Antes cada
     ficha tenía su propio recuadro `[data-flash]` metido en su sitio del
     formulario, así que en una página larga podía quedar fuera de la
     pantalla y el cliente no se enteraba. Ahora es uno solo, pegado arriba
     de la ventana, por encima de todo, y se cierra solo. Una llamada nueva
     reemplaza el aviso anterior en vez de amontonarlos. */
  var avisoEl = null, avisoT = null;
  C.aviso = function (msg, ms) {
    if (!avisoEl) {
      avisoEl = document.createElement('div');
      avisoEl.className = 'crg-aviso';
      avisoEl.setAttribute('role', 'status');
      avisoEl.addEventListener('click', function () { avisoEl.classList.remove('is-on'); });   // al tocarlo se cierra
      document.body.appendChild(avisoEl);
    }
    avisoEl.textContent = msg;
    // reinicia la animación de entrada aunque ya estuviera visible
    avisoEl.classList.remove('is-on');
    void avisoEl.offsetWidth;
    avisoEl.classList.add('is-on');
    clearTimeout(avisoT);
    avisoT = setTimeout(function () { avisoEl.classList.remove('is-on'); }, ms || 7000);
  };

  /* Subida con porcentaje real. fetch() no sabe decir cuánto se ha enviado,
     XMLHttpRequest sí, y aquí importa: un diseño puede pesar 20 MB. */
  C.subir = function (url, datos, alAvanzar) {
    return new Promise(function (listo, falla) {
      var x;
      try { x = new XMLHttpRequest(); } catch (e) { x = null; }
      if (!x || !('upload' in x)) {
        // navegador antiguo: se sube igual, sin porcentaje
        return fetch(url, { method: 'POST', body: datos, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.text().then(function (txt) {
            var j = null; try { j = JSON.parse(txt); } catch (e2) {}
            listo({ ok: r.ok, status: r.status, json: j });
          }); }, falla);
      }
      x.open('POST', url, true);
      x.setRequestHeader('Accept', 'application/json');
      if (alAvanzar) {
        x.upload.onprogress = function (e) {
          if (e.lengthComputable) alAvanzar(e.loaded / e.total * 100);
        };
        x.upload.onload = function () { alAvanzar(100); };
      }
      x.onload = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) {}
        listo({ ok: x.status >= 200 && x.status < 300, status: x.status, json: j });
      };
      x.onerror = function () { falla(new Error('red')); };
      x.ontimeout = function () { falla(new Error('red')); };
      x.send(datos);
    });
  };

  /* ---------- ¿ESTAMOS SOBRE NEGRO? ----------
   *
   * El verde corporativo está pensado sobre blanco; sobre el fondo oscuro del
   * tema se apaga y el texto verde deja de leerse. En cargando.css hay dos
   * juegos del mismo color y esto es lo único que decide cuál se usa: se mira
   * de qué color es el fondo DE VERDAD y, si es oscuro, <html> se lleva la
   * clase `imp-oscuro`.
   *
   * No vale con mirar el <body>: casi siempre es transparente y el color lo
   * pone algo de más arriba o de más abajo. Así que se sube por los padres
   * hasta encontrar uno que pinte algo, y si nadie pinta nada, blanco, que es
   * lo que hace el navegador.
   *
   * Se hace aquí y no en cada ficha porque este fichero lo cargan las cinco. */
  function color(el) {
    while (el && el.nodeType === 1) {
      var c = getComputedStyle(el).backgroundColor || '';
      var m = c.match(/^rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > .2)) {
        return [+m[1], +m[2], +m[3]];
      }
      el = el.parentElement;
    }
    return [255, 255, 255];
  }

  C.oscuro = function (el) {
    var c = color(el || document.body || document.documentElement);
    // la misma cuenta de luz que se usa para saber si una tela es oscura
    return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255 < 0.45;
  };

  C.paleta = function () {
    var raiz = document.documentElement;
    if (!raiz) return;
    raiz.classList.toggle('imp-oscuro', C.oscuro());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', C.paleta);
  } else {
    C.paleta();
  }

  window.Cargando = C;
})();